<!-- <app-jjsv-header [isLoggedIn]="isLoggedIn" [navLinks]="navLinks"></app-jjsv-header> -->
@let loginComponent = (loginComponent$ | async);
<div class="login-container row">
  <!-- On mobile: content first (order-1), image second (order-2) -->
  <div class="login_image col-12 col-lg-6 d-flex align-items-center justify-content-center order-2 order-lg-1">
    <img
      src="/assets/images/user-hero.png"
      [alt]="translations.heroAlt"
      class="img-fluid login-hero__image"
    />
  </div>
  <div class="login_content col-12 col-lg-6 d-flex align-items-start justify-content-center flex-column order-1 order-lg-2">
    <div class="chime_agent d-flex align-items-center justify-content-start gap-2">
      <span>
        <img [src]="baseUrl + loginComponent?.loginLogo?.url" [alt]="loginComponent?.loginLogo?.code || 'CHiME agent logo'" />
      </span>
      <span class="chime_agent_title">{{ loginComponent?.loginTitle }}</span>
    </div>
    <p class="chime_desc mt-0 mb-0">
      {{ loginComponent?.loginDescription }}
    </p>
    @let isSessionExpired = (isSessionExpired$ | async);
    @if (isSessionExpired) {
    <div class="errorMessage-expired">
      <div>
        <img
          src="/assets/svgs/info.svg"
          alt="Error icon"
          class="errorIcon"/>
      </div>
      <div>
        <div class="errorMessageText1">You’ve been logged out</div>
        <div class="errorMessageText2">Your session timed out after {{ ((currentIdleTimeout$ | async) / 60 ).toFixed(0) }} minutes of inactivity.
        Log in again to resume your work safely.</div>
      </div>
    </div>
    }
    @let loginErrorMessage = (loginErrorMessage$ | async);
    @if (loginErrorMessage) {
    <div class="errorMessage">
      <div>
        <img
          src="/assets/svgs/Alert.svg"
          alt="Error icon"
          class="errorIcon"/>
      </div>
      <div>
        <div class="errorMessageText1">Login failed</div>
        <div class="errorMessageText2">{{ loginErrorMessage }}</div>
      </div>
    </div>
    }
    <div class="chime_btn mt-4">
      <button class="btn login-hero__btn" (click)="onSsoLogin()">
        {{ translations.loginButtonLabel }} 
        <span class="login-hero__btn-icon">
          <img src="/assets/svgs/Arrow-right.svg" alt="Arrow right icon" />
        </span>
      </button>
    </div>
  </div>
</div>